export const SALARY_ISSUES_QUERY_KEY = 'salaryIssuesQueryKey'
